export default __webpack_public_path__ + "static/media/service_3.e7f1f917.jpg";